<template>
  <div>
    <ActivitySearch/>
    <ActivityResults/>
  </div>
</template>

<script>
import  ActivitySearch  from '@/components/backend/ActivitySearch.vue'
import  ActivityResults from '@/components/backend/ActivityResults.vue'

export default {
  name: 'UsersView',
  components: {
    ActivitySearch,
    ActivityResults
    
  }
}
</script>

<style scoped>

</style>
